import { Component, type ErrorInfo, type ReactNode, useEffect } from 'react';
import { RouterProvider } from '@tanstack/react-router';
import { entry, router } from '@/routes';

class AppErrorBoundary extends Component<{ children: ReactNode }, { failed: boolean }> {
  state = { failed: false };

  static getDerivedStateFromError() {
    return { failed: true };
  }

  componentDidCatch(_error: Error, _info: ErrorInfo) {}

  render() {
    if (this.state.failed) {
      return <main className="grid min-h-screen place-items-center p-6">We could not open Hive Register.</main>;
    }
    return this.props.children;
  }
}

function AppRuntime() {
  useEffect(() => {
    document.getElementById('root')?.setAttribute('data-app-ready', '1');
    const routes = Object.values(router.routesById)
      .filter((route) => route.id !== '__root__')
      .map((route) => {
        const data = route.options.staticData;
        if (
          !data ||
          typeof data !== 'object' ||
          !('title' in data) ||
          !('page' in data) ||
          !('standalone' in data) ||
          !('isPublic' in data) ||
          typeof data.title !== 'string' ||
          typeof data.page !== 'string' ||
          typeof data.standalone !== 'boolean' ||
          typeof data.isPublic !== 'boolean'
        ) {
          throw new Error(`Route ${route.id} has incomplete static inventory data.`);
        }
        return {
          pattern: route.fullPath.replace(/\$([^/]+)/g, '[$1]'),
          path: route.fullPath,
          title: data.title,
          page: data.page,
          standalone: data.standalone,
          isPublic: data.isPublic,
        };
      });
    globalThis.__onautoRouteInventory = { routes, entry };
  }, []);

  return <RouterProvider router={router} />;
}

export function App() {
  return (
    <AppErrorBoundary>
      <AppRuntime />
    </AppErrorBoundary>
  );
}
